

































































import {
  Component,
  Emit,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class PrefectureSelect extends Vue {
  @Prop({ default: '選択してください' })
  pref!: string;

  prefecture!: string;

  @Emit('setPrefecture')
  setPrefecture() {
    return this.prefecture;
  }

  private get innerPrefecture() {
    return this.prefecture;
  }

  private set innerPrefecture(prefecture) {
    this.prefecture = prefecture;
    this.setPrefecture();
  }
}
